// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-tagcheckbox-list[data-v-273b5df6]{display:flex;flex-wrap:wrap}.m-tagcheckbox-list__item[data-v-273b5df6]{display:inline-flex;margin-top:5px}.m-tagcheckbox-list__item[data-v-273b5df6]:not(:last-child){margin-right:5px}", ""]);
// Exports
module.exports = exports;
